export default "1536px"